import { UNCHECKED, PARTIAL, CHECKED } from '../checkbox/Checkbox'

import {
  walk,
  getNodeByPath,
  getDescendantLeafs
} from '../util/treeUtils'

/**
 * Updates selection states.
 * If a node changed we need to update the node itself, ancestors and descendants.
 *
 * @param {Array} shadowTree
 * @param {Object} changedNodePath
 */
const updateSelection = (shadowTree, changedNodePath) => {
  const node = getNodeByPath(shadowTree, changedNodePath)

  // First update the changed node itself
  if (node.isParent) {
    // Click on a parent means: Select all or none of its children
    switch (node.checkboxStatus) {
      case UNCHECKED:
        node.checkboxStatus = CHECKED
        break
      case PARTIAL:
        node.checkboxStatus = CHECKED
        break
      case CHECKED:
        node.checkboxStatus = UNCHECKED
        break
      default:
        console.warn('Unknown checkbox status', node.checkboxStatus)
        node.checkboxStatus = UNCHECKED
    }

    // Same status for all children
    walk(node.children, child => { child.checkboxStatus = node.checkboxStatus })
  } else {
    // If not a parent simply toggle
    node.checkboxStatus = (node.checkboxStatus === CHECKED) ? UNCHECKED : CHECKED
  }

  // Then update descendant/parent status
  updateParents(shadowTree)
}

const updateParents = shadowTree => {
  getDescendantLeafs(shadowTree, (node, leafs) => {
    const numSelected = leafs.filter(leaf => leaf.checkboxStatus === CHECKED).length

    if (numSelected === leafs.length) { node.checkboxStatus = CHECKED } else if (numSelected > 0) { node.checkboxStatus = PARTIAL } else { node.checkboxStatus = UNCHECKED }

    node.numSelected = numSelected
  })
}

const clearAll = shadowTree => {
  walk(shadowTree, node => {
    node.checkboxStatus = UNCHECKED
    if (node.isParent) node.numSelected = 0
  })
}

const setStatusFromValues = (shadowTree, values) => {
  walk(shadowTree, node => {
    if (!node.isParent) {
      node.checkboxStatus = (values.indexOf(node.value) !== -1) ? CHECKED : UNCHECKED
    }
  })

  updateParents(shadowTree)
}

export {
  updateSelection,
  updateParents,
  clearAll,
  setStatusFromValues
}
